import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { FieldNumber, FormBuilderData, FormBuilderFieldType } from './form-builder.model';

function numberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === '') {
      return null;
    }

    const value = Number(control.value);
    return isNaN(value) ? { not_a_number: true } : null;
  };
}

function integerValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === '') {
      return null;
    }

    const value = Number(control.value);
    return !Number.isInteger(value) ? { not_an_integer: true } : null;
  };
}

export function getValidators(item: FormBuilderData): ValidatorFn[] {
  const validators = [];
  const field = item;

  if (field.required) {
    validators.push(Validators.required);
  }

  switch (field.type) {
    case FormBuilderFieldType.STRING:
      if (field.minLength) validators.push(Validators.minLength(field.minLength));
      if (field.maxLength) validators.push(Validators.maxLength(field.maxLength));
      if (field.pattern) validators.push(Validators.pattern(field.pattern));
      break;

    case FormBuilderFieldType.NUMBER:
      validators.push(numberValidator());
      if ((item as FieldNumber).format === 'integer') {
        validators.push(integerValidator());
      }
      if (field.min !== undefined) validators.push(Validators.min(field.min));
      if (field.max !== undefined) validators.push(Validators.max(field.max));
      break;

    // The control holds the raw `partial-time` string, so the schema pattern can
    // guard it directly: an edit that drops the seconds is then reported on the
    // field instead of travelling to the backend for rejection.
    case FormBuilderFieldType.TIME:
      if (field.pattern) validators.push(Validators.pattern(field.pattern));
      break;

    case FormBuilderFieldType.DATE:
      if (field.minDate) {
        validators.push(Validators.min(new Date(field.minDate).getTime()));
      }
      if (field.maxDate) {
        validators.push(Validators.max(new Date(field.maxDate).getTime()));
      }
      break;
  }

  return validators;
}
